import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const ANALYTICS_ENDPOINT = '/analytics';
const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY || 'moftah_auth_token';

// Create axios instance
const api = axios.create({
  baseURL: API_URL
});

// Add request interceptor to attach the token to all requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Get dashboard analytics
export const getDashboardAnalytics = async () => {
  try {
    const response = await api.get(`${ANALYTICS_ENDPOINT}/dashboard`);
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard analytics:', error);
    throw error;
  }
};

// Get sales trend data
export const getSalesTrend = async (period = 'month') => {
  try {
    const response = await api.get(`${ANALYTICS_ENDPOINT}/sales-trend`, {
      params: { period }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales trend data:', error);
    throw error;
  }
};

// Get top selling products
export const getTopSellingProducts = async (limit = 5) => {
  try {
    const response = await api.get(`${ANALYTICS_ENDPOINT}/top-products`, {
      params: { limit }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching top selling products:', error);
    throw error;
  }
}; 